<template>
  <div>
    <button
      type="button"
      class="btn btn-dark btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-upload" />
      </span>
      Bulk
    </button>

    <a-modal v-model="visible" title="Bulk Upload Staff" :width="680" style="top: 20px;" @cancel="handleCancel">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Upload</a-button>
      </template>

      <a-form :form="form">
<!--        <p>Select Session and class section to upload students.</p>
        <div class="row">
          <div class="col-md-4 mb-2">
            <a-form-item
              label="Session"
            >
              <a-select
                v-decorator="[
                  'session_id',
                  {rules: [{ required: true, message: 'Please select a session!!' }], initialValue: currentSession ? currentSession.id : ''}
                ]"
                placeholder="Select session"
                @change="handleSessionChange"
              >
                <a-select-option v-for="schoolSession in schoolSessions" :value="schoolSession.id" :key="schoolSession.id">
                  {{schoolSession.name}}
                  <small class="text-primary ml-3">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <div class="col-md-4 mb-2">
            <a-form-item
              label="Class"
            >
              <a-spin :spinning="classSpinning">
                <a-select
                  v-decorator="[
                    'class_id',
                    {rules: [{ required: false, message: 'Please select a class!!' }], initialValue: undefined}
                  ]"
                  placeholder="Select class"
                  @change="handleClassSelect"
                  :disabled="!selectedSession"
                >
                  <a-select-option :value="undefined">
                    Select Class
                  </a-select-option>
                  <template v-for="schoolClass in schoolClasses">
                    <a-select-option :value="schoolClass.id" :key="schoolClass.id">
                  {{schoolClass.name}}
                  </a-select-option>
                  </template>
                </a-select>
              </a-spin>
            </a-form-item>
          </div>

          <div class="col-md-4 mb-2">
            <a-form-item
              label="Section"
            >
              <a-spin :spinning="sectionSpinning">
                <a-select
                  v-decorator="[
                    'section_id',
                    {rules: [{ required: false, message: 'Please select a section!!' }], initialValue: undefined}
                  ]"
                  placeholder="Select section"
                  :disabled="!form.getFieldValue('class_id')"
                >
                    <a-select-option :value="undefined">
                      Select Section
                    </a-select-option>
                    <a-select-option v-for="section in sections" :value="section.id" :key="section.id">
                    {{section.name}}
                    </a-select-option>
                </a-select>
              </a-spin>
            </a-form-item>
          </div>

        </div>

        <a-divider /> -->
        <div class="row">
          <div class="col-md-6 mb-2">
            <a-form-item
              label="Action"
            >
              <a-select
                v-decorator="[
                  'action',
                  {rules: [{ required: true, message: 'Please select an action!!' }]}
                ]"
                placeholder="Select action"
              >
                <a-select-option  :value="0" >Bulk Add</a-select-option>
                <a-select-option  :value="1" >Bulk Update</a-select-option>
                <a-select-option  :value="2" >Bulk Staff Subject Add/Delete</a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>
        <p class="mt-3 mb-0">Please read the instruction file
          <a
            href="/resources/instructions/bulk_staff_instruction.txt"
            class="btn btn-sm btn-primary btn-with-addon mx-3"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-download" />
            </span>
            Download Instruction
          </a>
        </p>
        <p class="mt-3 mb-0">Download the csv file format here.
          <a
            href="/resources/csv/bulk_staff_add.csv"
            class="btn btn-sm btn-primary btn-with-addon mx-3"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-download" />
            </span>
            Bulk Staff Add
          </a>
          <a
            href="/resources/csv/bulk_staff_subject_import.csv"
            class="btn btn-sm btn-primary btn-with-addon mx-3"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-download" />
            </span>
            Bulk Staff Subject Add/Delete
          </a>
<!--          <span class="font-weight-bold text-warning">Fields marked with * are required!</span>-->
        </p>
        <div class="row">
          <div class="col-md-4">
            <a-form-item
              label="CSV File"
            >
              <a-upload
                v-decorator="['file', {rules: [{ required: true, message: 'Please select a csv file to upload!' }]}]"
                accept=".csv, application/vnd.ms-excel, text/csv"
                :fileList="fileList"
                :multiple="false"
                :remove="handleRemove"
                :beforeUpload="beforeUpload"
                :disabled="uploadDisabled"
              >
                <a-button v-if="!uploadDisabled">
                  <a-icon type="upload" /> Select File
                </a-button>
              </a-upload>
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { find } from 'lodash'

const options = {
  showLeafArrayIndexes: true,
  includeNullValues: false,
  mapping: function(value) {
    if (typeof value === 'boolean') {
      return +value ? '1' : '0'
    }
    return value
  },
}

export default {
  name: 'BulkUploadStaff',
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id

        this.getClasses()
      })
      .catch(error => {
        console.log(error)
      })
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      uploadDisabled: false,
      fileList: [],
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      selectedSession: undefined,
      classSpinning: false,
      sectionSpinning: false,
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.uploadDisabled = false
    },
    beforeUpload (file) {
      const isCSV = file.type === 'application/vnd.ms-excel' || file.type === 'text/csv'
      if (!isCSV) {
        this.$message.error('You can only upload CSV file!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('File must smaller than 2MB!')
        return false
      }
      this.fileList = [...this.fileList, file]
      // return isJPG && isLt2M
      this.uploadDisabled = true
      return false
    },
    getClasses: function() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      this.form.resetFields(['section_id'])
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
      }
    },
    getClassSections(value) {
      this.$http.get(`/api/section/class/${value}`, {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }

      this.form.resetFields(['class_id', 'section_id'])

      this.getClasses()
    },
    getAction(actionValue) {
      if (actionValue === 0) return 'ADD_STAFF'
      if (actionValue === 1) return 'UPDATE_STAFF'
      if (actionValue === 2) return 'UPSERT_SUBJECT'
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        values['action'] = this.getAction(values['action'])
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to bulk upload staffs!`,
            onOk: () => {
              let formData = window.jsonToFormData(values, options)

              const csvFile = values.file.file
              formData.append('file', csvFile)

              this.$http
                .post('/api/staff/bulk', formData)
                .then(({ data }) => {
                  this.$emit('uploaded')
                  this.$eventBus.$emit('calendarEventUpdated')
                  this.loading = false
                  this.visible = false
                  this.$notification['info']({
                    message: 'Bulk upload started!',
                    description: `Bulk staff upload has started! You will be notified once it is completed!`,
                  })
                  this.fileList = []
                  this.uploadDisabled = false
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.form.resetFields()
      this.visible = false
    },
  },
}
</script>
